import { render, staticRenderFns } from "./workTest.vue?vue&type=template&id=2ad6022a&scoped=true"
import script from "./workTest.vue?vue&type=script&lang=js"
export * from "./workTest.vue?vue&type=script&lang=js"
import style0 from "./workTest.vue?vue&type=style&index=0&id=2ad6022a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad6022a",
  null
  
)

export default component.exports